import { useLocation } from 'react-router-dom';
import { EmptyStateFind, PermissionsNeeded } from 'ui/illustrations';
import { displayContent } from '../content';
import { EditorError, StyledLink, TEMPLATE_EDITOR_ERROR_LINK_BACK_TEST_ID } from './EditorError';

export const TemplateCorruptedError = () => {
  const { pathname, search } = useLocation();
  const params = new URLSearchParams(search);
  params.delete('locale');

  return (
    <EditorError
      image={
        <EmptyStateFind height={296.5} width={296.5} data-test="permission-needed-illustration" />
      }
      linkBack={
        <StyledLink
          to={`${pathname}?${params.toString()}`}
          data-test={TEMPLATE_EDITOR_ERROR_LINK_BACK_TEST_ID}
        >
          {displayContent.linkBackToTemplateDefaultLocale}
        </StyledLink>
      }
      message={displayContent.strTemplateCorruptedDesc}
      title={displayContent.errTemplateCorrupted}
    />
  );
};

export const TemplateViewPermissionError = () => (
  <EditorError
    image={
      <PermissionsNeeded height={296.5} width={296.5} data-test="permission-needed-illustration" />
    }
    message={displayContent.strViewTemplatePermissionDesc}
    title={displayContent.errViewTemplatePermission}
  />
);

export const TemplateNotFoundError = () => (
  <EditorError
    image={
      <EmptyStateFind height={296.5} width={296.5} data-test="empty-state-find-illustration" />
    }
    message={displayContent.strNoTemplateFoundDesc}
    title={displayContent.errNoTemplateFound}
  />
);
